/** Removes all trailing '/' characters from a URL base. Safe from ReDoS (no backtracking regex). */
export function trimTrailingSlashes(s: string): string {
  let end = s.length;
  while (end > 0 && s[end - 1] === '/') end -= 1;
  return s.slice(0, end);
}
